"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-top: 2px solid ", ";\n  border-right: 2px solid ", ";\n  border-bottom: 2px solid ", ";\n  border-left: 2px solid ", ";\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  vertical-align: text-bottom;\n  animation: ", " 0.8s infinite linear;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg) }\n  100% { transform: rotate(1turn) }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var rotate = (0, _styledComponents.keyframes)(_templateObject());

var getColor = function getColor(props, highlight) {
  var color = '0, 0, 0';
  var opacity = highlight ? 0.4 : 0.08;

  if (props.inverse) {
    color = '255, 255, 255';
    opacity = highlight ? 0.85 : 0.2;
  }

  return "rgba(".concat(color, ", ").concat(opacity, ")");
};

var StyledSpinner = _styledComponents["default"].span(_templateObject2(), function (props) {
  return getColor(props);
}, function (props) {
  return getColor(props);
}, function (props) {
  return getColor(props);
}, function (props) {
  return getColor(props, true);
}, function (props) {
  if (props.size === 'small') return '1em';
  if (props.size === 'medium') return '2em';
  if (props.size === 'large') return '3em';
}, function (props) {
  if (props.size === 'small') return '1em';
  if (props.size === 'medium') return '2em';
  if (props.size === 'large') return '3em';
}, rotate);

var Spinner = function Spinner(props) {
  return _react["default"].createElement(StyledSpinner, props);
};

Spinner.propTypes = {
  inverse: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large'])
};
Spinner.defaultProps = {
  inverse: false,
  size: 'small'
};
var _default = Spinner;
exports["default"] = _default;